import React from 'react';

export const BuyNowButton = () => (
  <button name="buy_now_submit" type="submit">
    Buy Now!
  </button>
);
